export interface InsufficientSampleResult {
  hasInsufficientSample: boolean;
  countText: string;
  warningMessage: string;
}

export const DEFAULT_MIN_SAMPLE_SIZE = 5;

export function checkSampleSize(
  sampleSize: number | undefined,
  minSampleSize: number = DEFAULT_MIN_SAMPLE_SIZE,
): InsufficientSampleResult {
  const hasInsufficientSample =
    typeof sampleSize === "number" &&
    sampleSize >= 0 &&
    sampleSize < minSampleSize;

  if (!hasInsufficientSample) {
    return {
      hasInsufficientSample: false,
      countText: "",
      warningMessage: "",
    };
  }

  const countText =
    sampleSize === 0
      ? "nenhuma sala semelhante cadastrada"
      : sampleSize === 1
        ? "apenas 1 sala semelhante cadastrada"
        : `apenas ${sampleSize} salas semelhantes cadastradas`;

  const warningMessage =
    `Ainda não conseguimos calcular a média de preço para este bairro, ` +
    `pois encontramos ${countText}. ` +
    `A análise é exibida quando há pelo menos ${minSampleSize} salas na região.`;

  return {
    hasInsufficientSample: true,
    countText,
    warningMessage,
  };
}
